import React from 'react';
import classnames from 'classnames';
import styles from './AlgorithmButton.module.css';


const AlgorithmButton = ({componentBlock, contentData, id, changeData, title}) => (
  <div
    className={classnames({
      [styles.wrap]: true,
      [styles.visibleWrap]: componentBlock.visibility,
      [styles.invisibleWrap]: !componentBlock.visibility
    })}
  >
    {contentData.map(item => (
      <div
        id={item.key}
        key={item.key}
      >
        <button
          id={item.key}
          className={classnames({
            [styles.button]: true,
            [styles.buttonChecked]: item.checked,
            [styles.buttonUnchecked]: !item.checked
          })}
          onClick={(e) => {
            if (e.target.id == item.key) {
              changeData(id, !item.checked, item.key, item, componentBlock);
            }
          }}
        >
          {title}
        </button>
      </div>
    ))}
  </div>
)

export default AlgorithmButton;